// Tri glavne kategorije pocetna
export const HOME_CATEGORY_REQUEST = 'HOME_CATEGORY_REQUEST';
export const HOME_CATEGORY_SUCCESS = 'HOME_CATEGORY_SUCCESS';
export const HOME_CATEGORY_FAIL = 'HOME_CATEGORY_FAIL';
